var _line, _line2, _line3, _line4, _line5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrosshairMediumGreen(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#29A858",
    strokeMiterlimit: 10,
    x1: 50,
    y1: 30,
    x2: 50,
    y2: 46
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#29A858",
    strokeMiterlimit: 10,
    x1: 46,
    y1: 50,
    x2: 30,
    y2: 50
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#29A858",
    strokeMiterlimit: 10,
    x1: 70,
    y1: 50,
    x2: 54,
    y2: 50
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#29A858",
    strokeMiterlimit: 10,
    x1: 50,
    y1: 54,
    x2: 50,
    y2: 70
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#29A858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 50,
    y1: 50,
    x2: 50,
    y2: 50
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshairMediumGreen);
export default __webpack_public_path__ + "static/media/crosshair-medium-green.7a719b2279d9f01faff31e4d81c47230.svg";
export { ForwardRef as ReactComponent };